import { axios, Response } from '../index'

export interface Body {
  identifier: string
  macroAreaName: string
  macroAreaBodyView: string
  posX: number
  posY: number
}

const updateMacroArea = (id: string, request: Body): Response<null> => {
  return axios.put(`/v1/macro-areas/${id}`, request)
}

export default updateMacroArea
